import React from 'react';
import { 
    Grid, 
    TextField,
    Paper,
    Typography,
    MenuItem,
    FormControl, 
    FormLabel, 
    RadioGroup, 
    FormControlLabel, 
    Radio,
    Checkbox,
    FormHelperText,
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
} from "@material-ui/core";
import SignatureCanvas from 'react-signature-canvas';
import desistir from '../../../../global/imagenes/desistir.png';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { FORM_DICTIONARY } from './schemas/formFields';

const CARD_STYLES = {
    card: {
        maxWidth: 320,
        width: '100%',
        minHeight: 200,
        cursor: 'pointer',
        borderRadius: 10,
        boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.08)',
        transition: 'transform 0.12s ease, box-shadow 0.12s ease',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 24,
        padding: '12px 10px',
        background: '#fff',
        cursor: 'pointer',
        hover: { 
            boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.12)', 
            transform: 'scale(1.02)', 
            maxWidth: 320,
        },
    },
    cardHeader: { fontSize: '0.95rem', fontWeight: 700, textAlign: 'center', color: '#111', marginBottom: 6 },
    cardImage: { width: 48, height: 48, objectFit: 'cover', display: 'block', margin: '0 auto 6px' },
    cardDescription: { fontSize: '0.85rem', lineHeight: '1.35', color: '#666', margin: '0px 8px', textAlign: 'justify', paddingLeft: 8, paddingRight: 8 },
    cardDescriptionAdvertencia: { fontSize: '0.85rem', lineHeight: '1.35', color: '#ec4b4bff', margin: '0px 8px', textAlign: 'justify', paddingLeft: 8, paddingRight: 8 },
};


export function FormularioDesentimientoTrasladoEPSBienestar({
    onSeleccionar,
    completada = false,
    disabled = false,
    modoLectura = false,
    modoAdministrador = false,
    mensajeDeshabilitado = '',
    mostrarMensajeDeshabilitado = false,
}) {
    const estaDeshabilitado = modoAdministrador ? (!completada || disabled) : (completada || disabled);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', position: 'relative' }}>
            <Paper
                style={{
                    ...CARD_STYLES.card,
                    position: 'relative',
                    cursor: estaDeshabilitado ? 'not-allowed' : 'pointer',
                    opacity: estaDeshabilitado ? 0.6 : 1,
                    filter: estaDeshabilitado ? 'grayscale(60%)' : 'none',
                }}
                elevation={2}
                onClick={() => !estaDeshabilitado && onSeleccionar?.('disentimiento')}
            >
                {completada && (
                    <span style={{ position: 'absolute', top: 12, right: 12 }}>
                        <CheckCircleIcon style={{ color: 'rgb(90, 227, 94)', fontSize: 38 }} />
                    </span>
                )}
                <img src={desistir} alt="Desistir" style={{ width: 48, height: 48, marginBottom: 6, objectFit: 'contain' }} />
                <Typography style={CARD_STYLES.cardHeader}>DISENTIMIENTO INFORMADO DE TRASLADO PARA ATENCIÓN EPS MODALIDAD INDIVIDUAL</Typography>
                {estaDeshabilitado && mostrarMensajeDeshabilitado && (
                    <Typography style={{ ...CARD_STYLES.cardDescription, marginTop: 8 }}>
                        {mensajeDeshabilitado || 'Este formato aún no ha sido diligenciado por el estudiante.'}
                    </Typography>
                )}
            </Paper>
        </div>
    );
}

export function FormularioDisentimientoTrasladoEPS({
    state,
    onChange,
    onError,
    servicio,
    profesionalesOpciones = [],
    ProteccionDatosComponent,
    activeStep = 0,
    firmaRefEstudiante,
    firmaRefAcudiente,
    limpiarFirma,
}) {
    const steps = [
        'Protección de datos',
        'Datos personales',
        'Reconocimiento y profesional',
        'Acudiente y decisiones',
        'Firmas',
    ];

    const campos = FORM_DICTIONARY.disentimiento_traslado;

    const safeValue = (field) => {
        if (!state || !state[field]) return "";
        return typeof state[field].valor !== "undefined" ? state[field].valor : "";
    };

    const safeError = (field) => {
        if (!state || !state[field]) return "";
        return state[field].error || "";
    };

    const renderStep1 = () => (
        <Grid container spacing={3} style={{ marginTop: 10 }}>
            {ProteccionDatosComponent && (
                <Grid item xs={12}>
                    {ProteccionDatosComponent}
                </Grid>
            )}
        </Grid>
    );


    const renderStep2 = () => (
        <Grid container spacing={3} style={{ marginTop: 10 }}>

            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    required
                    label={campos.nombre.label}
                    name={campos.nombre.name}
                    value={safeValue(campos.nombre.name)}
                    onChange={onChange}
                    error={!!safeError(campos.nombre.name)}
                    helperText={safeError(campos.nombre.name)}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    required
                    label={campos.documento.label}
                    name={campos.documento.name}
                    value={safeValue(campos.documento.name)}
                    onChange={onChange}
                    error={!!safeError(campos.documento.name)}
                    helperText={safeError(campos.documento.name)}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    disabled
                    fullWidth
                    required
                    label={campos.servicio.label}
                    name={campos.servicio.name}
                    value={servicio?.nombre || ''}
                    InputProps={{ readOnly: true }}
                />
            </Grid>
        </Grid>
    );

    const renderStep3 = () => (
        <Grid container spacing={3} style={{ marginTop: 10 }}>
            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 16, backgroundColor: '#f9f9f9', borderLeft: '4px solid #e53935' }}>
                    <Typography variant="body2" style={{ textAlign: 'justify', marginBottom: 8 }}>
                        Reconozco haber sido informado sobre los posibles pasos de la ruta,
                        incluyendo el traslado a Área Protegida y acompañamiento del acudiente
                        a la ambulancia para su posterior traslado a entidades de salud para la
                        prevención del suicidio.
                        <br /><br />
                        Entiendo que este procedimiento hace parte del protocolo y de las rutas
                        de atención establecidas, y reconozco que el profesional a cargo cuenta
                        con la idoneidad y el entrenamiento necesarios para emitir dicha indicación.
                        <br /><br />
                        Sin embargo,{' '}
                        <strong>
                            no estoy de acuerdo con el traslado a “Área Protegida” y acompañamiento
                            del acudiente a la ambulancia para su posterior traslado a entidades de salud.
                        </strong>
                    </Typography>

                    <FormControl error={!!safeError(campos.Rinformacion.name)} component="fieldset">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name={campos.Rinformacion.name}
                                    checked={safeValue(campos.Rinformacion.name) === "SI"}
                                    onChange={(e) =>
                                        onChange({
                                            target: {
                                                name: campos.Rinformacion.name,
                                                value: e.target.checked ? "SI" : ""
                                            }
                                        })
                                    }
                                />
                            }
                            label={campos.Rinformacion.label}
                        />
                        {safeError(campos.Rinformacion.name) && (
                            <FormHelperText>{safeError(campos.Rinformacion.name)}</FormHelperText>
                        )}
                    </FormControl>
                </Paper>
            </Grid>

            <Grid item xs={12}>
                <TextField
                    fullWidth
                    required
                    select
                    label={campos.Profesional.label}
                    name={campos.Profesional.name}
                    value={safeValue(campos.Profesional.name)}
                    onChange={onChange}
                    error={!!safeError(campos.Profesional.name)}
                    helperText={safeError(campos.Profesional.name) || "Selecciona el profesional"}
                >
                    {profesionalesOpciones.map((prof) => (
                        <MenuItem key={prof.value} value={prof.label}>
                            {prof.label}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
        </Grid>
    );

    const renderStep4 = () => (
        <Grid container spacing={3} style={{ marginTop: 10 }}>

            {/* Datos acudiente */}
            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label={campos.acudiente.label}
                    name={campos.acudiente.name}
                    value={safeValue(campos.acudiente.name)}
                    onChange={onChange}
                    error={!!safeError(campos.acudiente.name)}
                    helperText={safeError(campos.acudiente.name)}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label={campos.ID_acudiente.label}
                    name={campos.ID_acudiente.name}
                    value={safeValue(campos.ID_acudiente.name)}
                    onChange={onChange}
                    error={!!safeError(campos.ID_acudiente.name)}
                    helperText={safeError(campos.ID_acudiente.name)}
                />
            </Grid>

            {/* Pregunta 1 */}
            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 16, backgroundColor: '#fafafa', borderRadius: 4 }}>
                    <FormControl fullWidth error={!!safeError(campos.comunicacion_decision.name)}>
                        <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                            {campos.comunicacion_decision.label}
                        </Typography>

                        <RadioGroup
                            name={campos.comunicacion_decision.name}
                            value={safeValue(campos.comunicacion_decision.name)}
                            onChange={onChange}
                        >
                            <FormControlLabel value="SI" control={<Radio />} label="Sí" />
                            <FormControlLabel value="NO" control={<Radio />} label="No" />
                        </RadioGroup>
                        {safeError(campos.comunicacion_decision.name) && (
                            <FormHelperText>{safeError(campos.comunicacion_decision.name)}</FormHelperText>
                        )}
                    </FormControl>
                </Paper>
            </Grid>

            {/* Pregunta 2 */}
            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 16, backgroundColor: '#fafafa', borderRadius: 4 }}>
                    <FormControl fullWidth error={!!safeError(campos.disposicion_decisiones.name)}>
                        <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                            {campos.disposicion_decisiones.label}
                        </Typography>

                        <RadioGroup
                            name={campos.disposicion_decisiones.name}
                            value={safeValue(campos.disposicion_decisiones.name)}
                            onChange={onChange}
                        >
                            <FormControlLabel value="SI" control={<Radio />} label="Sí" />
                            <FormControlLabel value="NO" control={<Radio />} label="No" />
                        </RadioGroup>
                        {safeError(campos.disposicion_decisiones.name) && (
                            <FormHelperText>{safeError(campos.disposicion_decisiones.name)}</FormHelperText>
                        )}
                    </FormControl>
                </Paper>
            </Grid>

            {/* Confirmación responsabilidad */}
            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 16, backgroundColor: '#f9f9f9', borderRadius: 4 }}>
                    <FormControl fullWidth error={!!safeError(campos.confirmacion_responsabilidad.name)}>
                        <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                            <strong>{campos.confirmacion_responsabilidad.titulo}</strong>
                        </Typography>

                        <Typography variant="body2" style={{ textAlign: 'justify', marginBottom: 8 }}>
                            {campos.confirmacion_responsabilidad.description}
                        </Typography>

                        <FormControlLabel
                            control={
                                <Checkbox
                                    name={campos.confirmacion_responsabilidad.name}
                                    checked={safeValue(campos.confirmacion_responsabilidad.name) === "SI"}
                                    onChange={(e) =>
                                        onChange({
                                            target: {
                                                name: campos.confirmacion_responsabilidad.name,
                                                value: e.target.checked ? "SI" : ""
                                            }
                                        })
                                    }
                                />
                            }
                            label={campos.confirmacion_responsabilidad.label}
                        />
                        {safeError(campos.confirmacion_responsabilidad.name) && (
                            <FormHelperText>{safeError(campos.confirmacion_responsabilidad.name)}</FormHelperText>
                        )}
                    </FormControl>
                </Paper>
            </Grid>

            {/* Declaración */}
            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 16, backgroundColor: '#f9f9f9', borderRadius: 4 }}>
                    <FormControl fullWidth error={!!safeError(campos.declaracion_disentimiento.name)}>
                        <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                            <strong>Declaración de disentimiento informado</strong>
                        </Typography>

                        <Typography variant="body2" style={{ textAlign: 'justify', marginBottom: 8 }}>
                            Declaro que he sido informado de manera clara y comprensiva sobre el objetivo, alcance y beneficios
                            de la activación de la ruta de protección a la vida, así como de las opciones de acompañamiento
                            disponibles. He tenido la oportunidad de expresar mis inquietudes, recibir orientación y resolver
                            mis dudas con total libertad.
                            <br /><br />
                            No obstante, manifiesto de forma voluntaria y consciente <strong>mi decisión de no continuar</strong> con la
                            activación de dicha ruta en este momento, asumiendo la responsabilidad sobre el cuidado de mi salud
                            emocional y bienestar integral.
                            <br /><br />
                            Reconozco que la Universidad de la Costa – CUC pone a disposición este servicio como una muestra de su
                            compromiso con el bienestar de la comunidad estudiantil y comprendo que esta decisión no limita mi
                            derecho a acceder a los servicios de apoyo en el futuro si así lo requiero.
                            <br /><br />
                            <strong>
                                Al firmar este documento, reconozco que la Universidad y su equipo profesional no tienen ninguna
                                responsabilidad relacionada con esta decisión, la cual tomo de manera libre e informada.
                            </strong>
                        </Typography>

                        <FormControlLabel
                            control={
                                <Checkbox
                                    name={campos.declaracion_disentimiento.name}
                                    checked={safeValue(campos.declaracion_disentimiento.name) === "SI"}
                                    onChange={(e) =>
                                        onChange({
                                            target: {
                                                name: campos.declaracion_disentimiento.name,
                                                value: e.target.checked ? "SI" : ""
                                            }
                                        })
                                    }
                                />
                            }
                            label={campos.declaracion_disentimiento.label}
                        />
                        {safeError(campos.declaracion_disentimiento.name) && (
                            <FormHelperText>{safeError(campos.declaracion_disentimiento.name)}</FormHelperText>
                        )}
                    </FormControl>
                </Paper>
            </Grid>

            {/* Importante */}
            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 16, backgroundColor: '#fff3e0', borderLeft: '4px solid #fb8c00', borderRadius: 4 }}>
                    <FormControl fullWidth error={!!safeError(campos.importante_aceptacion.name)}>
                        <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                            IMPORTANTE
                        </Typography>

                        <Typography variant="body2" style={{ textAlign: 'justify' }}>
                            El presente disentimiento informado deberá ser diligenciado en un plazo máximo de 48 (cuarenta y ocho)
                            horas a partir de su recepción. En caso de no recibir respuesta dentro del plazo establecido, se
                            entenderá por parte de la institución que:
                        </Typography>

                        <Typography
                            component="ul"
                            variant="body2"
                            style={{ paddingLeft: 20, marginTop: 8, marginBottom: 8 }}
                        >
                            <li>El usuario no desea continuar con el servicio ofrecido.</li>
                            <li>El presente documento se hace válido automáticamente.</li>
                        </Typography>

                        <Typography variant="body2" style={{ textAlign: 'justify', marginBottom: 8 }}>
                            Si el estudiante es menor de edad o no se encuentra en plena capacidad para otorgar su disentimiento,
                            este documento debe ser diligenciado por su representante legal o acudiente autorizado.
                        </Typography>

                        <FormControlLabel
                            control={
                                <Checkbox
                                    name={campos.importante_aceptacion.name}
                                    checked={safeValue(campos.importante_aceptacion.name) === "SI"}
                                    onChange={(e) =>
                                        onChange({
                                            target: {
                                                name: campos.importante_aceptacion.name,
                                                value: e.target.checked ? "SI" : ""
                                            }
                                        })
                                    }
                                />
                            }
                            label={campos.importante_aceptacion.label}
                        />
                        {safeError(campos.importante_aceptacion.name) && (
                            <FormHelperText>{safeError(campos.importante_aceptacion.name)}</FormHelperText>
                        )}
                    </FormControl>
                </Paper>
            </Grid>

        </Grid>
    );

    const renderStep5 = () => (
        <Grid container spacing={3} style={{ marginTop: 10 }}>
            <Grid item xs={12}>
                <Typography variant="subtitle1" align="center" style={{ fontWeight: 700, marginBottom: 12 }}>
                    Firmas
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" align="center" gutterBottom style={{ fontWeight: 'bold' }}>
                            Firma del estudiante
                        </Typography>
                        <Box style={{ border: '2px solid #bbb', backgroundColor: '#f9f9f9', borderRadius: 4 }}>
                            <SignatureCanvas
                                ref={firmaRefEstudiante}
                                penColor="black"
                                canvasProps={{ height: 200, style: { width: '100%', display: 'block' } }}
                            />
                        </Box>
                        {typeof limpiarFirma === 'function' && (
                            <Button
                                size="small"
                                variant="outlined"
                                color="secondary"
                                onClick={() => limpiarFirma(firmaRefEstudiante)}
                                style={{ marginTop: 8 }}
                            >
                                Limpiar firma estudiante
                            </Button>
                        )}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" align="center" gutterBottom style={{ fontWeight: 'bold' }}>
                            Firma del acudiente o representante
                        </Typography>
                        <Box style={{ border: '2px solid #bbb', backgroundColor: '#f9f9f9', borderRadius: 4 }}>
                            <SignatureCanvas
                                ref={firmaRefAcudiente}
                                penColor="black"
                                canvasProps={{ height: 200, style: { width: '100%', display: 'block' } }}
                            />
                        </Box>
                        {typeof limpiarFirma === 'function' && (
                            <Button
                                size="small"
                                variant="outlined"
                                color="secondary"
                                onClick={() => limpiarFirma(firmaRefAcudiente)}
                                style={{ marginTop: 8 }}
                            >
                                Limpiar firma acudiente
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </Grid>

        </Grid>
    );

    return (
        <>
            <Stepper activeStep={activeStep} alternativeLabel style={{ marginBottom: 16 }}>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            {activeStep === 0 && renderStep1()}
            {activeStep === 1 && renderStep2()}
            {activeStep === 2 && renderStep3()}
            {activeStep === 3 && renderStep4()}
            {activeStep === 4 && renderStep5()}
        </>
    );
}

